<template>
  <div class="pd-medium">
    <h2 class="h4 mn-b-medium">{{ $t('payments.history') }}</h2>

    <div v-if="loading" class="t-center pd-big">
      <Loader />
    </div>

    <div v-else-if="payments.length === 0" class="t-center pd-big">
      <p class="t-grey">{{ $t('payments.noPayments') }}</p>
    </div>

    <div v-else class="bg-white radius-medium pd-medium">
      <CardPayment
        v-for="(payment, index) in payments"
        :key="payment._id"
        :payment="payment"
        :isLast="index === payments.length - 1"
      />
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, inject } from 'vue';
import Loader from '@martyrs/src/design-system/components/Loader/Loader.vue';
import CardPayment from '../blocks/CardPayment.vue';

const store = inject('store');
const payments = ref([]);
const loading = ref(true);

onMounted(async () => {
  try {
    payments.value = await store.payments.actions.listPayments();
  } finally {
    loading.value = false;
  }
});
</script>
